<template>
  <!-- <div id="app">
    <router-view/>
  </div> -->
  <v-app>
    <!-- <v-navigation-drawer app></v-navigation-drawer> -->
    <!-- <v-toolbar app></v-toolbar> -->
    <v-content>
      <v-container
        fluid
        class="pa-0">
        <!-- <v-parallax jumbotron contain height="200" src="/static/banner_bg.jpg" /> https://cdn.vuetifyjs.com/images/parallax/material.jpg -->
        <v-parallax
          height="200"
          class="xs-parallax"
          :src="bannerUrl">
          <v-layout row>
            <v-flex
              xs1
              offset-md1>
              <v-img
                contain
                :src="logoUrl"
                width="125"
                height="200"
                @click="logoClick"
                class="xs-logo"/>
            </v-flex>
            <v-flex
              xs11
              md8>
              <v-layout
                fill-height
                column
                justify-center
                class="text-md-center text-xs-right">
                <h1 class="display-2 font-weight-thin mb-3 xs-heading">ระบบสารสนเทศงานวิจัยและนวัตกรรม</h1>
                <h4 class="subheading xs-subheading">มหาวิทยาลัยการกีฬาแห่งชาติ วิทยาเขตชุมพร</h4>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-parallax>
        <v-layout
          align-center
          justify-center>
          <router-view />
        </v-layout>
      </v-container>
    </v-content>
    <v-footer
      app
      class="pa-3">
      <v-spacer/>
      <div>&copy; {{ new Date().getFullYear() }}</div>
    </v-footer>
  </v-app>
</template>

<script>
export default {
  name: 'App',

  data () {
    return {
      bannerUrl: require('./assets/banner_bg.jpg'),
      logoUrl: require('./assets/logo.png')
    }
  },

  methods: {
    logoClick () {
      location.href = 'http://www.tnsucpn.ac.th/cpn/' // 'http://www.ipecp.ac.th/cpn/'
    }
  }
}
</script>

<style scoped>
@font-face {
  font-family: 'sarabun-bold';
  src: url('./assets/fonts/THSarabunNewBold.ttf') format('truetype');
  font-weight: bold;
  font-style: normal;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

table td {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
}

.xs-logo {
  cursor: pointer;
}
.xs-parallax >>> img {
 opacity: unset !important;
}
.xs-heading, .xs-subheading {
  font-family: 'sarabun-bold' !important;
  text-shadow: 1px 1px 10px #000;
}
.xs-heading {
  font-size: 46px !important;
}
.xs-subheading {
  font-size: 28px !important;
}

@media (max-width: 640px) {
  .xs-heading {
    font-size: 38px !important;
    line-height: 16px !important;
  }
}

@media (max-width: 560px) {
  .xs-heading {
    font-size: 32px !important;
    line-height: 14px !important;
  }
}

@media (max-width: 480px) {
  .xs-parallax {
    height: 120px !important;
  }
  .xs-logo {
    width: 75px !important;
    height: 120px !important;
  }
  .xs-heading {
    font-size: 28px !important;
    line-height: 20px !important;
  }
  .xs-subheading {
    font-size: 22px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue